import { render, staticRenderFns } from "./Batches.vue?vue&type=template&id=dbffda5e&"
import script from "./Batches.vue?vue&type=script&lang=js&"
export * from "./Batches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbffda5e')) {
      api.createRecord('dbffda5e', component.options)
    } else {
      api.reload('dbffda5e', component.options)
    }
    module.hot.accept("./Batches.vue?vue&type=template&id=dbffda5e&", function () {
      api.rerender('dbffda5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/batches/views/Batches.vue"
export default component.exports